import { EmbedHtmlBlockSchema } from '@blocksuite/hive-model';
import { BlockViewExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { createBuiltinToolbarConfigExtension } from './configs/toolbar';

const flavour = EmbedHtmlBlockSchema.model.flavour;

export const EmbedHtmlBlockSpec: ExtensionType[] = [
  BlockViewExtension(flavour, model => {
    return model.parent?.flavour === 'hive:surface'
      ? literal`hive-embed-edgeless-html-block`
      : literal`hive-embed-html-block`;
  }),
  createBuiltinToolbarConfigExtension(flavour),
].flat();
